import { UHttp } from '../../utils/UHttp';



export interface Availability{
  id: string;
  professionalId: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  type: string;
  status: string;
  day?: string;
  recurrence?: {
    startDate: Date;
    endDate: Date;
  };
}

export interface AvailabilityResponse {
  success: true,
  status: number,
  message: string,
  data: Availability[]
}

export interface AvailabilityOverviewDate {
  date: string;
  hasAvailability: boolean;
  firstAvailableSlot?: string;
  totalSlots: number;
}

export interface AvailabilityOverviewResponse {
  success: boolean,
  status: number,
  message: string,
  data?: AvailabilityOverviewDate[]
}




const apiUrlServer = process.env.REACT_APP_URL_SERVER

/**
 * Modèle pour gérer les interactions avec l'API concernant les disponibilités
 */
export class ClientAvailabilityProfessionalModel {
  private static instance: ClientAvailabilityProfessionalModel;

  private constructor() {}

  public static getInstance(): ClientAvailabilityProfessionalModel {
    if (!ClientAvailabilityProfessionalModel.instance) {
      ClientAvailabilityProfessionalModel.instance = new ClientAvailabilityProfessionalModel();
    }
    return ClientAvailabilityProfessionalModel.instance;
  }


  /**
   * Récupère les créneaux disponibles d'un collaborateur pour une date donnée
   * en tenant compte des rendez-vous existants et de la durée du service demandé
   * @param collaboratorCompagnieId ID du collaborator_compagnies
   * @param selectedOptionIds IDs des options sélectionnées pour calculer la durée additionnelle
   */
  async getProfessionalAvailability(
    collaboratorCompagnieId: string,
    serviceId?: string,
    serviceDuration?: number,
    date?: string,
    bufferTime?: number,
    selectedOptionIds?: string[],
    services?: Array<{ serviceId: string; optionIds?: string[] }>
  ): Promise<AvailabilityResponse> {
    try {
      const body: any = {
        collaboratorCompagnieId,
        date
      };

      // Mode multi-services
      if (services && services.length > 0) {
        body.services = services;
      } else {
        // Mode single service (backward compatibility)
        body.serviceId = serviceId;
        body.serviceDuration = serviceDuration;
        body.bufferTime = bufferTime;
        body.selectedOptionIds = selectedOptionIds || [];
      }

      const response = await UHttp.post(
        apiUrlServer + "/public-api/timeslot/client/collaborator/availability",
        body,
        UHttp.publicApiHeaders()
      );

      const responseData = await response.json();

      if (!response.ok) {
        console.error('Error response:', responseData);
      }

      return {
        ...responseData,
        status: response.status
      };
    } catch (error) {
      console.error('Error in getProfessionalAvailability:', error);
      throw error;
    }
  }

  /**
   * Récupère l'aperçu des disponibilités d'un collaborateur sur une période
   * Retourne pour chaque jour si des créneaux sont disponibles
   * Supporte single service et multi-services
   */
  async getProfessionalAvailabilityOverview(
    collaboratorCompagnieId: string,
    serviceId?: string,
    serviceDuration?: number,
    startDate?: string,
    endDate?: string,
    selectedOptionIds?: string[],
    services?: Array<{ serviceId: string; optionIds?: string[] }>
  ): Promise<AvailabilityOverviewResponse> {
    try {
      const body: any = {
        collaboratorCompagnieId,
        startDate,
        endDate
      };

      // Mode multi-services
      if (services && services.length > 0) {
        body.services = services;
      } else {
        // Mode single service (backward compatibility)
        body.serviceId = serviceId;
        body.serviceDuration = serviceDuration;
        body.selectedOptionIds = selectedOptionIds || [];
      }

      const response = await UHttp.post(
        apiUrlServer + "/public-api/timeslot/client/collaborator/availability-overview",
        body,
        UHttp.publicApiHeaders()
      );

      const responseData = await response.json();

      // Log de la réponse
      if (!response.ok) {
        console.error('Error response:', responseData);
      }

      return {
        ...responseData,
        status: response.status
      };
    } catch (error) {
      console.error('Error in getProfessionalAvailabilityOverview:', error);
      throw error;
    }
  }

}

